import React from "react"
import Cabecalho from "../Cabecalho"
import { ListaAvaliacoes } from "./components/ListaAvaliacoes"

export function AvaliacaoDelivery() {
    return (
        <>
            <Cabecalho pagina="Avaliações do Delivery" />
            <ListaAvaliacoes />
        </>
    )
}
